import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ASSIGNABLE_ROLES, ROLE_GUIDE } from '../../../constants/userRoles';
import { ROLE_ICONS, roleLabel } from './roleVisuals';
import styles from './UserFormPopup.module.css';

/**
 * Escolha do papel em cards. Abaixo dos cards, o que o papel escolhido
 * acessa e o que fica de fora, para decidir sem abrir outro guia.
 * `options` limita os papéis a quem chama pode atribuir (assignableRolesFor).
 */
function RolePicker({ value, onChange, options = ASSIGNABLE_ROLES }) {
  const guide = ROLE_GUIDE[value];

  return (
    <div className={styles.rolePicker}>
      <div className={styles.roleOptions} role="radiogroup" aria-label="Papel">
        {options.map((role) => {
          const Icon = ROLE_ICONS[role];
          const selected = value === role;
          return (
            <button
              key={role}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`${styles.roleOption} ${selected ? styles.selected : ''}`}
              onClick={() => onChange(role)}
            >
              <span className={styles.roleIcon}><Icon fontSize="small" /></span>
              <span className={styles.roleName}>{roleLabel(role)}</span>
              <span className={styles.roleTagline}>{ROLE_GUIDE[role].tagline}</span>
            </button>
          );
        })}
      </div>

      {guide && (
        <div className={styles.roleSummary}>
          <ul>
            {guide.can.map((item) => (
              <li key={item} className={styles.can}><CheckRoundedIcon className={styles.mark} />{item}</li>
            ))}
          </ul>
          <ul>
            {guide.cannot.map((item) => (
              <li key={item} className={styles.cannot}><CloseRoundedIcon className={styles.mark} />{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default RolePicker;
